/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CRSFSecReviewTechSource = {
    Asm: 'asm',
    Firehose: 'firehose',
    External: 'external'
} as const;
export type CRSFSecReviewTechSource = typeof CRSFSecReviewTechSource[keyof typeof CRSFSecReviewTechSource];


export function CRSFSecReviewTechSourceFromJSON(json: any): CRSFSecReviewTechSource {
    return CRSFSecReviewTechSourceFromJSONTyped(json, false);
}

export function CRSFSecReviewTechSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewTechSource {
    return json as CRSFSecReviewTechSource;
}

export function CRSFSecReviewTechSourceToJSON(value?: CRSFSecReviewTechSource | null): any {
    return value as any;
}

